import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo-container-left" }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = { router: "" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "user-thumb" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "el-dropdown-link" }

import { ElAvatar, ElRow, ElCol, ElHeader, ElLink, ElIcon } from 'element-plus';
import 'element-plus/dist/index.css';
import WeChatIcon from './WeChatIcon.vue';
import 'element-plus/theme-chalk/display.css';
import { onMounted, ref, watch } from 'vue';
import wxQrcodeImage from '../assets/wxminiprogram.jpg';
import { jwtDecode } from "jwt-decode"
import {loginStore} from '../stores/scene';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeadCom',
  setup(__props) {

const logStore = loginStore();
const isLoggedIn = ref(false); // 假设用户未登录，实际应用中应从状态管理或API获取
const userThumb = ref("");
onMounted(() => {
    // 这里可以添加实际的登录状态检查逻辑
    if (localStorage.getItem('jwtToken')) {
        isLoggedIn.value = true;
        let jwttoken = localStorage.getItem('jwtToken');
        let docde = jwtDecode(jwttoken);
        userThumb.value = docde?.UserThumb ?? '';
    } else {
        isLoggedIn.value = false;
    }
});
watch(()=>[logStore.isLogin, logStore.avatar],([newVal,newthumb])=>{
    if (newVal) {
        isLoggedIn.value=newVal;
    } else {
        isLoggedIn.value = false;
    }
    if(newthumb){
        userThumb.value = newthumb;
    }else{
        userThumb.value = "";
    }

},{immediate:true});


const unregist = () => {

    localStorage.removeItem('jwtToken');
    // localStorage.removeItem('refreshToken');//临时
    isLoggedIn.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_unref(ElHeader), { class: "head-com" }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ElCol), {
            xs: 24,
            sm: 12,
            class: "logo-container"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(ElAvatar), {
                  shape: "square",
                  class: "logo",
                  src: "../assets/logo.png"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "title" }, "上赛云社区", -1))
              ]),
              _createVNode(_component_el_dropdown, { class: "menuicon hidden-sm-and-up" }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("首页")
                        ])),
                        _: 1,
                        __: [6]
                      }),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("关于我们")
                        ])),
                        _: 1,
                        __: [7]
                      }),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("帮助")
                        ])),
                        _: 1,
                        __: [8]
                      }),
                      _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("登录")
                        ])),
                        _: 1,
                        __: [9]
                      }),
                      _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("注册")
                        ])),
                        _: 1,
                        __: [10]
                      }),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), {
                            class: "icon",
                            name: "wechat"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(WeChatIcon)
                            ]),
                            _: 1
                          }),
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "微信小程序", -1))
                        ]),
                        _: 1,
                        __: [11]
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Menu)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(ElCol), {
            sm: 12,
            class: "hidden-xs-only"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", null, [
                  _createVNode(_unref(ElLink), {
                    title: "首页",
                    href: "/",
                    underline: "never"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("span", null, "首页", -1)
                    ])),
                    _: 1,
                    __: [12]
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_unref(ElLink), {
                    title: "关于我们",
                    href: "/about",
                    underline: "never"
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createElementVNode("span", null, "关于我们", -1)
                    ])),
                    _: 1,
                    __: [13]
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_unref(ElLink), {
                    title: "帮助",
                    href: "/help",
                    underline: "never"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("span", null, "帮助", -1)
                    ])),
                    _: 1,
                    __: [14]
                  })
                ]),
                (isLoggedIn.value)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(ElAvatar), {
                          src: userThumb.value,
                          size: "small",
                          style: {"margin-right":"8px"}
                        }, null, 8, ["src"]),
                        _createVNode(_unref(ElLink), {
                          title: "注销",
                          underline: "never",
                          onClick: unregist
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createElementVNode("span", null, "注销", -1)
                          ])),
                          _: 1,
                          __: [15]
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createVNode(_unref(ElLink), {
                        title: "登录",
                        href: "/login",
                        underline: "never",
                        icon: "UserFilled"
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createElementVNode("span", null, "登录", -1)
                        ])),
                        _: 1,
                        __: [16]
                      })
                    ])),
                (isLoggedIn.value)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                      _createVNode(_component_el_dropdown, { style: {"vertical-align":"middle","font-weight":"500"} }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'MySource' })))
                              }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("资源")
                                ])),
                                _: 1,
                                __: [18]
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'MyOrders' })))
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode("订单")
                                ])),
                                _: 1,
                                __: [19]
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'MyInvoices' })))
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode("发票")
                                ])),
                                _: 1,
                                __: [20]
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'ModifyUserInfo' })))
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode("个人信息")
                                ])),
                                _: 1,
                                __: [21]
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'ResetPwd' })))
                              }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode("修改密码")
                                ])),
                                _: 1,
                                __: [22]
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_8, [
                            _cache[17] || (_cache[17] = _createTextVNode(" 我的")),
                            _createVNode(_unref(ElIcon), { class: "el-icon--right" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowDown)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", null, [
                  _createVNode(_unref(ElLink), {
                    title: "注册新用户",
                    href: "/regist",
                    underline: "never"
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createElementVNode("span", null, "注册", -1)
                    ])),
                    _: 1,
                    __: [23]
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_el_popover, { trigger: "hover" }, {
                    reference: _withCtx(() => [
                      _createVNode(_unref(ElLink), {
                        title: "微信小程序",
                        underline: "never"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElIcon), {
                            class: "icon",
                            name: "wechat"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(WeChatIcon)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, { src: _unref(wxQrcodeImage) }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})